<template>
	<div id="historical-profile-table">
		<h3 class="line-header">Live Profile History</h3>
		<v-data-table
			:headers="headers"
			:items="deployedProfileHistoryList"
			:items-per-page="10"
			:hide-default-footer="deployedProfileHistoryList.length <= 10"
			mobile-breakpoint="500"
			item-key="profileId"
			class="historical-profile-data-table"
			v-if="deployedProfileHistoryList && deployedProfileHistoryList.length > 0">

			<template v-slot:item.view-details="{ item }">
				<v-btn text @click="viewDetails(item.profileId, item.deployEndDateTime)">
					View Details
				</v-btn>
			</template>
		</v-data-table>
		<div
			v-else-if="deployedProfileHistoryList && deployedProfileHistoryList.length === 0"
			class="historical-profile-table-empty"
		>
			<h3>So fresh! There's no history to show.</h3>
			<img class="empty-state-graphic" src="@/assets/imgs/empty-fresh-leaf.svg">
			<div>After you deploy a new profile, your old profile will be listed here with a basic performance summary.</div>
		</div>
		<v-skeleton-loader v-else type="table"></v-skeleton-loader>
		
	</div>
</template>

<script>
	/**
	 * @fileoverview historical-profile-table.vue displays the list of previously deployed profiles for the active tenant.
	 * It relies on vuex to map the state variables from the store files.
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import { mapState } from 'vuex';

	export default {
		data() { 
			return {
				/**
				 * Headers for the historical profile data table
				 */
				headers: [
					{
						text: "Live Start Date",
						align: "start",
						value: "deployStartDateTime",
						sortable: false,
					},
					{
						text: "Live End Date",
						align: "start",
						value: "deployEndDateTime",
						sortable: false,
					},
					{
						text: "Profile",
						align: "start",
						value: "profileLabel",
						sortable: false,
					},
					{
						text: "",
						value: "view-details",
						align: "center",
						sortable: false,
					},
				],
			}
		},
		computed: {
			...mapState({
				deployedProfileHistoryList: (state) => state.config.deployedProfileHistoryList,
				activeTenantId: (state) => state.account.activeTenantId,
			})
		},
		methods: {
			/**
			 * View the details of a historical profile
			 * @param {String} profileId - profile Id for the selected profile
			 * @param {String} deployEndDateTime - last active date
			 */
			async viewDetails(profileId, deployEndDateTime) {
				let payload = {
					profileId: profileId,
					tenantId: this.activeTenantId,
				}

				await this.$store.dispatch("retrieveProfile", payload);
				await this.$store.dispatch("retrieveProfilePerformance", payload);

				let detailsPayload = {
					profileId: profileId,
					deployEndDateTime: deployEndDateTime
				};

				this.$emit("viewDetails", detailsPayload);
			}
		}
	}
</script>

<!-- Styles defined in _historical-profile-table.scss -->